import React from 'react';
import { LDContext, LDProvider, useLDClient } from 'launchdarkly-react-client-sdk';
import { SessionData, useSessionData } from '../auth/SessionDataHook';
import { useEffect } from 'react';

type Props = {
  children: React.ReactNode;
};

export function FeatureFlagProvider({ children }: Props) {
  const { session, isLoading } = useSessionData();
  const ldClient = useLDClient();
  const context = buildContext(session);

  useEffect(() => {
    if (context) {
      ldClient?.identify(context);
    }
  }, [context, ldClient]);

  return (
    <LDProvider
      deferInitialization
      clientSideID={import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID}
      context={context}
    >
      {!isLoading && children}
    </LDProvider>
  );
}

function buildContext(session: SessionData | null): LDContext | undefined {
  if (!session) {
    return;
  }

  const metadata = session.identity?.metadata_public;
  const { tenantId, userId } = metadata;

  return {
    key: 'user-info',
    kind: 'user-info',
    userId: userId,
    tenant: tenantId,
  };
}
